import React from 'react';
import {connect} from 'react-redux';

import RegularMatch from './RegularMatch.jsx';

import * as DisplayMode from 'constants/DisplayMode';
import * as FavouriteState from 'constants/FavouriteState';

import {cssClassMap} from 'rendering-commons/SportCssMap';
import {matchSortFunc, matchStartDateSortFunc} from 'rendering-commons/Sorting';

function filterMatches(matches, filter) {
    if (filter === null || filter === undefined) {
        return matches;
    }

    const date = new Date();

    const dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);

    return matches.filter(m => m.get('startDate') <= dateFilter);
}

class League extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        filter: React.PropTypes.number,
        league: React.PropTypes.object,
        sport: React.PropTypes.object,
        matchId: React.PropTypes.any,
        matches: React.PropTypes.object.isRequired,
        displayMode: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        gridSelection: React.PropTypes.object.isRequired,
        selectionToggleMatchAction: React.PropTypes.func.isRequired
    };

    shouldComponentUpdate(nextProps) {
        return this.props.league !== nextProps.league ||
            this.props.displayMode !== nextProps.displayMode ||
            this.props.filter !== nextProps.filter;
    }

    static renderMatch(match, props) {
        const matchId = match.get('id');

        return (<RegularMatch key={matchId} id={matchId} {...props} />);
    }

    render() {
        const {
            section,
            sport,
            league,
            displayMode,
            matches,
            gridLocalization,
            matchId,
            gridSelection,
            selectionToggleMatchAction
        } = this.props;

        if (league === undefined || sport === undefined) {
            return false;
        }

        const sportId = sport.get('id');

        const matchIds = league.get('matches');

        let showTitle = true;
        let showLeague = true;

        if (section === 'live') {
            if (displayMode.type === DisplayMode.FAVOURITE) {
                const favouriteState = league.get('favouriteState');
                if (favouriteState === FavouriteState.NONE) {
                    showLeague = false;
                }
            } else if (displayMode.type === DisplayMode.SPORT) {
                if (sportId !== displayMode.id) {
                    showLeague = false;
                }
            } else if (displayMode.type === DisplayMode.LEAGUE) {
                if (league.get('id') !== displayMode.id) {
                    showLeague = false;
                }
            } else if (displayMode.type === DisplayMode.MATCH) {
                const containsSelectedMatch = matchIds.includes(displayMode.id);

                if (containsSelectedMatch) {
                    showTitle = false;
                } else {
                    showLeague = false;
                }
            }
        }

        if (!showLeague) {
            return false;
        }

        let leagueMatches = matchIds.map((m) => matches.get(m));

        if (section === 'preMatch') {
            leagueMatches = filterMatches(leagueMatches, this.props.filter);
        }

        if (leagueMatches.size === 0) {
            return false;
        }

        const sortedMatches = leagueMatches.sort(section === 'live' ? matchSortFunc : matchStartDateSortFunc);

        const sportCssName = cssClassMap[sportId];

        const leagueClass = 'league ' + sportCssName;
        const sportIconClass = 'sport-icon svg-' + sportCssName;

        const leagueName = league.get('name');
        const sportName = sport.get('name');

        const matchProps = {
            section,
            gridLocalization,
            matchId,
            gridSelection,
            selectionToggleMatchAction
        };

        return (
            <div className={leagueClass}>
                {showTitle && <div className="title">
                    <i className={sportIconClass}/>
                    <strong>{sportName + '. '}</strong>
                    <span>{leagueName}</span>
                </div>}
                {sortedMatches.map((m) => League.renderMatch(m, matchProps))}
            </div>
        );
    }
}

function select(state, props) {
    const {section, id, gridLocalization, filter, matchId} = props;
    const league = state.application.getIn([section, 'leagues', id]);

    let sport;

    if (league !== undefined) {
        const sportId = league.get('sportId');
        sport = state.application.getIn([section, 'sports', sportId]);
    }

    return {
        section,
        filter,
        sport,
        league,
        matchId,
        matches: state.application.getIn([section, 'matches']),
        displayMode: state.application.get('displayMode'),
        gridLocalization,
        gridSelection: props.gridSelection,
        selectionToggleMatchAction: props.selectionToggleMatchAction
    };
}

export default connect(select, null, null, false)(League);


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/League.jsx